import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onProceed: () => void;
  modalKey?: string;
}

function GradeAWarn({ isOpen, onClose, onProceed, modalKey }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      key={modalKey ?? "warning_module"}
    >
      <ModalOverlay />
      <ModalContent
        bg="danger.500"
        color="white"
        borderRadius="md"
        boxShadow="md"
        p={4}
      >
        <ModalHeader>Info</ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody>
          <Text>
            This movie has been rated &apos;A&apos; and is only for audiences
            above the age of 16. Please carry a valid ID/Age Proof to the
            theater and audience(s) shall be able to present the proof if
            required or asked by the Management.
          </Text>
          <Text fontStyle="italic" mt={2}>
            No Cancellation, Exchange or Refund of tickets once bought.
          </Text>
          <Flex alignItems={"center"} justifyContent={"end"} gap={2}>
            <Button
              colorScheme="whiteAlpha"
              bg="white"
              size="sm"
              mt={4}
              onClick={onClose}
              textColor={"danger.500"}
            >
              Cancel
            </Button>
            <Button
              colorScheme="white"
              variant="outline"
              size="sm"
              mt={4}
              onClick={onProceed}
            >
              Proceed
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default GradeAWarn;
